import jwtDecode from 'jwt-decode';
export var isValidToken = function isValidToken(accessToken) {
  if (!accessToken) return false;
  var decoded = jwtDecode(accessToken);
  var currentTime = Date.now() / 1000;
  return decoded.exp > currentTime;
};